// extracted by mini-css-extract-plugin
module.exports = {"reference-item":"endpoints-webhook-card-list_reference-item__6ncXs"};